<template>
    <div class="pwresetform">
        <!-- POST to the current page, the plugin will catch the action  -->
        <form method="POST">
            <input type="hidden" name="action" value="change-password">
            <!-- i don't need this field, but chrome wants it for accessibility (...?) -->
            <input type="hidden" name="username" :value="memberemail">

            <div class="row" v-if="resetpwtoken === ''">
                <label id="oldpassword">{{enteroldpw}}</label>
                <input type="password" class="form-control" v-model="oldpw"
                       aria-describedby="oldpassword" name="oldpassword">
            </div>
            <div v-else>
                <input type="hidden" name="resettoken" :value="resetpwtoken"/>
            </div>

            <div class="row">
                <label id="newpassword">{{enternewpw}}</label>
                <input type="password" class="form-control" v-model="pw1"
                       aria-describedby="newpassword" name="newpassword1" autocomplete="new-password">
            </div>
            <div class="row">
                <label id="passwordrepeat">{{repeatnewpw}}</label>
                <input type="password" class="form-control" v-model="pw2"
                       aria-describedby="passwordrepeat" name="newpassword2" autocomplete="new-password">
            </div>
            <div class="row">
                <small>{{explainpwrequirements}}</small>
            </div>
            <div class="row">
                <button v-show="messagepw === ''" class="btn btn-success">{{okbuttontext}}</button>
            </div>
            <div class="row">
                <small v-if="messagepw !== '' && pw2.length <= 7" class="col alert alert-info">{{messagepw}}</small>
                <small v-if="messagepw !== '' && (pw2.length > 7)" class="col alert alert-danger">{{messagepw}}</small>
            </div>
        </form>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                oldpw: '',
                pw1: '',
                pw2: '',
                messagepw: '',
                mutableToken: this.resetpwtoken
            }
        },
        props: {
            resetpwtoken: {
                type: String,
                validator: function (value) {
                    // The value must have a length of 128 characters
                    return value.length === 128;
                }
            },

            memberemail: {
                type: String,
                required: false,
                default: 'member email'
            },

            enternewpw: {
                type: String,
                required: true
            },

            enteroldpw: {
                type: String,
                required: true
            },

            repeatnewpw: {
                type: String,
                required: true
            },
            okbuttontext: {
                type: String,
                required: true
            },
            explainpwrequirements: {
                type: String
            },
            messagepwnotstrongenoughyet: {
                type: String,
                required: true
            },
            messagepw1notyetequalpw2: {
                type: String,
                required: true
            }
        },
        methods: {
            checkNewPassword() {
                this.messagepw = '';
                let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
                if(this.pw1 !== '') {
                    if (!strongRegex.test(this.pw1)) {
                        this.messagepw = this.messagepwnotstrongenoughyet;
                    } else if (this.pw1 !== this.pw2) {
                        this.messagepw = this.messagepw1notyetequalpw2;
                    }
                }
            }
        },
        watch: {
            pw1() {
                this.checkNewPassword()
            },
            pw2() {
                this.checkNewPassword()
            }
        }
    }
</script>
